module.exports = __webpack_public_path__ + "static/media/country_mr.db634263.webp";